import * as React from 'react';
import {AutoComplete} from 'antd';
import {AutoCompleteHelper, AutoCompleteOption} from "./auto-complete-helper";
import {SelectValue} from "antd/lib/select";

interface Props {
  style?: React.CSSProperties;
  size?: 'large' | 'default' | 'small';
  dataSource: string[];
  value?: string;
  disabled?: boolean;
  onChange?: (value: SelectValue) => void;
  className?: string;
  allowClear?: boolean;
  placeholder?: string;
}

interface State {
  autoCompleteHelper?: AutoCompleteHelper<string>;
  typeDataSource: string[];
}

class AutoCompleteInput extends React.Component<Props, State> {
  public state: State = {
    typeDataSource: [],
  };

  public componentDidMount() {
    this.onSourceChanged();
  }

  public componentDidUpdate(prevProps: Readonly<Props>) {
    if (prevProps.dataSource !== this.props.dataSource) {
      this.onSourceChanged();
    }
  }

  public render(): React.ReactNode {
    const {style, size, disabled, placeholder, value, className, allowClear} = this.props;
    const {typeDataSource} = this.state;

    return (
      <AutoComplete
        size={size}
        style={style}
        placeholder={placeholder}
        className={className || 'mild-disabled'}
        dataSource={typeDataSource}
        disabled={disabled}
        onSearch={this.onSearch}
        onChange={this.props.onChange}
        value={value}
        allowClear={allowClear}
      />
    );
  }

  private onSourceChanged = () => {
    const { dataSource } = this.props;
    const helperOptions: Array<AutoCompleteOption<string>> = dataSource.map(c => ({text: c, value: c}));

    this.setState({
      autoCompleteHelper: new AutoCompleteHelper(helperOptions),
      typeDataSource: dataSource,
    });
  };

  private onSearch = (value: string) => {
    const {autoCompleteHelper} = this.state;
    if (autoCompleteHelper) {
      this.setState({
        typeDataSource: autoCompleteHelper.search(value),
      });
    }
  };
}

export default AutoCompleteInput;


// WEBPACK FOOTER //
// ./src/common/input/AutoCompleteInput.tsx